console.log("GAR Wishlist 01")
let wishlistFormatted = false;
let modalOpened = false;
addEventListener("unload", (event) => { })

let observer = new MutationObserver((mutations) => {

    let body = document.querySelector('body').classList;
    if(wishlistFormatted == false){
        if(body.contains('swym-wishlist-container-rendered') || body.contains('swym-shared-wishlist-container-rendered')){

            // Wishlist page
            const wlItems = document.querySelectorAll('.swym-storefront-layout-grid-item-title');
            if(wlItems[0] && wlItems[0].innerHTML != ''){
                const wlButtons = document.querySelectorAll('.swym-storefront-layout-grid-item-add-to-cart-button');

                for(let b=0; b<wlButtons.length; b++){
                    let wlButtonParent = wlButtons[b].parentElement;
                    wlButtonParentLink = wlItems[0].getAttribute('href');
                    
                    let newButton = document.createElement("a");
                    newButton.innerHTML = "View product";
                    newButton.setAttribute('href', wlButtonParentLink);
                    newButton.setAttribute('class', 'link');
                    wlButtonParent.insertBefore(newButton, wlButtons[b]);
                    wlButtons[b].remove();

                }

                //observer.disconnect()
                wishlistFormatted = true;
                checkShareButton();
            }

            // Shared wishlist page
            const wlItemsShared = document.querySelectorAll('.swym-shared-wishlist-container-rendered .swym-is-button h2.swym-title');
            if(wlItemsShared[0] && wlItemsShared[0].innerHTML != ''){

                const wlButtons = document.querySelectorAll('.swym-add-to-cart-btn');
                for(let b=0; b<wlButtons.length; b++){
                    let wlButtonParent = wlButtons[b].parentElement;
                    let wlButtonParentLink = '#';
                    if(wlButtonParent.querySelector('.swym-wishlist-image-wrapper')){
                        wlButtonParentLink = wlButtonParent.querySelector('.swym-wishlist-image-wrapper').getAttribute('href');
                    }
                    let newButton = document.createElement("a");
                    newButton.innerHTML = "View product";
                    newButton.setAttribute('href', wlButtonParentLink);
                    newButton.setAttribute('class', 'link');
                    wlButtonParent.insertBefore(newButton, wlButtons[b]);

                    wlButtonParent.addEventListener('click', function(){
                        window.location = wlButtonParentLink;
                    });

                    wlButtons[b].remove();
                }

                //observer.disconnect()
                wishlistFormatted = true;

            }
        }
    }
    
    // Modal launched
    if(body.contains('swym-modal-active') && modalOpened == false){
        const shareX = document.querySelector('.swym-share-twitter');
        if(shareX){
            shareX.classList.add('swym-share-whatsapp')
            const shareXImg = shareX.querySelector('img');
            if(shareXImg) {
                shareXImg.setAttribute('src', 'https://cdn.shopify.com/s/files/1/0934/6541/1968/files/whatsapp_logo_green.png');
                shareXImg.setAttribute('alt', 'Share via Whatsapp');
            } 
            shareX.innerHTML = "WHATSAPP";

            shareX.addEventListener('click', function(){
                // get the share id
                const listIdDiv = document.getElementById('swym-storefront-layout-items-container');
                let link = '';
                if(listIdDiv){
                    const listId = listIdDiv.getAttribute('data-lid');
                    link = 'https://www.garrard.com/pages/swym-share-wishlist?hkey='+listId+'&lid='+listId+'&utm_source=swym-Wishlist&utm_medium=shared-wishlist&utm_campaign='+listId;
                }
                const text = 'Click this link to view my wishlist on Garrard.com, '+link;
                window.location = 'https://wa.me/?text='+encodeURIComponent(text);
            });
        }

        modalOpened = true;
    }
    else if(!body.contains('swym-modal-active')) {
        modalOpened = false;
    }
})

// Function added to fix the app:
// - Create list -> Go to Wishlist -> Login -> Back to Wishlist: the share does not display
// - This function looks for the share button and reloads causing it to display
function checkShareButton() {
    const shareButton = document.getElementById('swym-storefront-layout-collection-option-button');
    const loginUI = document.querySelector('swym-storefront-layout-login-user .swym-storefront-layout-login-button');
    // console.log('shareButton',shareButton)
    // console.log('loginUI',loginUI)
    if(!shareButton && !loginUI){
        window.location.reload();
    }
}

observer.observe(document.body, {
    childList: true
  , subtree: true
  , attributes: false
  , characterData: false
})

